var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{attrs:{"logo":"logos/logo_primary.png"},scopedSlots:_vm._u([{key:"links",fn:function(props){return [(_vm.$can('show management', 'materias'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Materias',
          icon: 'ni ni-umbrella-13',
          path: '/materias'
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Venta de Planes',
          icon: 'ni ni ni-basket text-green'
        }}},[_c('sidebar-item',{attrs:{"link":{
              name: 'Panel Ventas',
              path: '/ventas/'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Nueva Venta',
              path: '/ventas/crear'
            }}}),(_vm.$can('show nueva venta gmo peru', 'ventas'))?_c('sidebar-item',{attrs:{"link":{
              name: 'Nueva Venta GMO Perú',
              path: '/ventas/gmo-peru' 
            }}}):_vm._e()],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Planes',
          icon: 'ni ni-paper-diploma text-orange'
        }}},[(_vm.$can('show management', 'planes'))?_c('sidebar-item',{attrs:{"link":{
              name: 'Gestionar Planes',
              path: '/planes/'
            }}}):_vm._e(),(_vm.$can('show management', 'categorias'))?_c('sidebar-item',{attrs:{"link":{
              name: 'Gestionar Categorias',
              path: '/planes/categorias/'
            }}}):_vm._e(),(_vm.$can('show management', 'subcategorias'))?_c('sidebar-item',{attrs:{"link":{
              name: 'Gestionar Subcategorias',
              path: '/planes/subcategorias/'
            }}}):_vm._e()],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Administración Sistema',
          icon: 'ni ni-key-25 text-blue'
        }}},[(_vm.$can('show management', 'users'))?_c('sidebar-item',{attrs:{"link":{
              name: 'Gestionar Usuarios',
              path: '/admin/usuarios'
            }}}):_vm._e(),(_vm.$can('show management', 'equipos'))?_c('sidebar-item',{attrs:{"link":{
              name: 'Gestionar Equipos',
              path: '/admin/equipos'
            }}}):_vm._e(),(_vm.$can('show management', 'sucursales'))?_c('sidebar-item',{attrs:{"link":{
              name: 'Gestionar Sucursales',
              path: '/admin/sucursales'
            }}}):_vm._e(),(_vm.$can('show management', 'sponsors'))?_c('sidebar-item',{attrs:{"link":{
              name: 'Gestionar Sponsors',
              path: '/admin/sponsors'
            }}}):_vm._e()],1),(_vm.$can('show management', 'siniestros'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Siniestros',
          icon: 'fas fa-fire-extinguisher text-red'
        }}},[_c('sidebar-item',{attrs:{"link":{
              name: 'Gestionar siniestros',
              path: '/siniestros/ingresar'
            }}})],1):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Reportes',
          icon: 'fas fa-file-contract text-brown'
        }}},[(_vm.$can('show siniestro', 'reportes'))?_c('sidebar-item',{attrs:{"link":{
              name: 'Reportes Siniestros',
              path: '/reportes/siniestros'
            }}}):_vm._e(),(_vm.$can('show sponsor', 'reportes'))?_c('sidebar-item',{attrs:{"link":{
              name: 'Reportes Sponsor',
              path: '/reportes/sponsor'
            }}}):_vm._e(),(_vm.$can('show company', 'reportes'))?_c('sidebar-item',{attrs:{"link":{
              name: 'Reportes por Compañía',
              path: '/reportes/compañia'
            }}}):_vm._e()],1),(_vm.$can('show list', 'garantias'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Garantias',
          icon: 'ni ni-tag text-blue',
          path: '/garantias'
        }}}):_vm._e(),(_vm.$can('show activity', 'logs'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Registro de Actividad',
          icon: 'ni ni-sound-wave text-yellow',
          path: '/actividad'
        }}}):_vm._e()]}}])}),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1),_c('google-spin',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loadingStack),expression:"$store.state.loadingStack"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }